<loader [showLoader]="showLoader"></loader>
<div
    class="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        {{FormStatus}} Product Options
                                    </h3>
                                </div>
                            </div>

                        </div>
                        <div class="markedFields">
                            <span style="margin-left:10px;">* Marked fields are
                                mandatory</span>
                        </div>
                        <form class="m-login__form m-form" name="myform" #myform="ngForm" appFocusInvalidInput
                            (ngSubmit)="myform.form.valid && onSubmit(myform)" novalidate>
                            <div class="m-portlet__body">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Product Series:</label>
                                    <div class="col-lg-3">
                                        <input class="form-control m-input" type="text" name="productseries"
                                            [(ngModel)]="Optionsobj.SeriesName" #productseries="ngModel"
                                            [ngClass]="{ 'is-invalid':myform.submitted  && productseries.invalid || productseries?.touched && productseries.invalid}"
                                            placeholder="Enter Product Series" (keypress)="AvoidSpace($event)" required
                                            (change)="Optionsobj.SeriesName=Optionsobj.SeriesName.trim()" disabled>
                                        <div class="invalid-feedback"
                                            *ngIf="myform.submitted && productseries.invalid || productseries?.touched && productseries.invalid">
                                            <div *ngIf="myform.hasError('required', 'productseries')">
                                                Product series is required
                                            </div>
                                        </div>

                                    </div>

                                    <div class="offset-1"></div>
                                    <label class="col-lg-2  col-form-label">Product Model:</label>
                                    <div class="col-lg-3">
                                        <mat-select class="form-control" placeholder="Select Product Model"
                                            [(ngModel)]="SelectedModel" [ngStyle]="{'background-color': isEditable ? '#f4f5f8' : '#fff' }"
                                            [ngClass]="{ 'is-invalid':myform.submitted  && productmodel.invalid || productmodel?.touched && productmodel.invalid}"
                                            #productmodel="ngModel" multiple name="productmodel" [disabled]="isEditable"
                                            (selectionChange)="OnModelselected($event)">
                                            <mat-option *ngFor="let item of ProductModelarr" value="{{item.Id}}">
                                                {{item.ModelName}}</mat-option>
                                            <mat-option disabled *ngIf="ProductModelarr.length <= 0"
                                                value="No Data Found"> No Data Found </mat-option>
                                        </mat-select>

                                        <div class="invalid-feedback"
                                            *ngIf="myform.submitted && productmodel.invalid || productmodel?.touched && productmodel.invalid">
                                            <div *ngIf="myform.hasError('required', 'productmodel')">
                                                Product model is required
                                            </div>
                                        </div>
                                        <span class="fileext">
                                            Note: If no model is selected, option will be available for all
                                            models</span>
                                    </div>

                                </div>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Product Option: <span
                                            style="color:#f4516c;">&nbsp;*</span></label>
                                    <div class="col-lg-3">
                                        <input class="form-control" type="text" name="option"
                                            [(ngModel)]="Optionsobj.Option" #option="ngModel"
                                            [ngClass]="{ 'is-invalid':myform.submitted  && option.invalid || option?.touched && option.invalid}"
                                            placeholder="Enter Product Option" (keypress)="AvoidSpace($event)"
                                            maxlength="150" (change)="Optionsobj.Option=Optionsobj.Option.trim()"
                                            [disabled]="isEditable" required>
                                        <div class="invalid-feedback"
                                            *ngIf="myform.submitted && option.invalid || option?.touched && option.invalid">
                                            <div *ngIf="myform.hasError('required', 'option')">
                                                Product option is required</div>
                                        </div>

                                    </div>

                                </div>
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Price (₹):</label>
                                    <div class="col-lg-3">
                                        <input class="form-control m-input" type="text" name="price" min="0"
                                            [(ngModel)]="Optionsobj.Price" #price="ngModel" style="text-align:right;"
                                            [ngClass]="{ 'is-invalid':myform.submitted  && price.invalid || price?.touched && price.invalid}"
                                            placeholder="Enter Price" maxlength="7" pattern="[0-9]+"
                                            (keypress)="AvoidSpace($event);isNumberKey($event);"
                                            [disabled]="Optionsobj.IsPriceOnRequest || isEditable">
                                        <div class="invalid-feedback"
                                            *ngIf="myform.submitted && price.invalid || price?.touched && price.invalid">

                                            <div *ngIf="myform.hasError('pattern', 'price')">
                                                Price must be an integer</div>
                                        </div>
                                    </div>
                                    <div class="offset-1"></div>
                                    <div class="col-lg-3">
                                        <mat-checkbox name="dep2" #dep2="ngModel"
                                            [(ngModel)]="Optionsobj.IsPriceOnRequest" [disabled]="isEditable"
                                            (change)="onIsPriceOnRequest($event)">
                                            <label>Is Price On Request</label>
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>

                            <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                                <div class="m-form__actions m-form__actions--solid">
                                    <div class="row">
                                        <div class="col-lg-2"></div>
                                        <div class="col-lg-10">
                                            <button id="m_login_signin_submit" *ngIf="isEditable"
                                                [hidden]="!isProductOptionEditable"
                                                class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--air"
                                                (click)="EditDetails()">Edit</button>&nbsp;&nbsp;
                                            <button id="m_login_signin_submit" *ngIf="!isEditable"
                                                class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--air">Save</button>&nbsp;&nbsp;
                                            <a [routerLink]="['/Options',Optionsobj?.ProductSeries]"
                                                routerLinkActive="m-menu__item--active"
                                                class="btn btn-metal m-btn m-btn--air m-btn--custom">Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>